import { ChildProviderProps } from "@/types";
import { PanelProps, PanelPropsContextType } from "@/types/diagram";
import React, { useState, createContext, useContext } from "react";

// Create the context with an initial undefined value
export const PanelPropsContext = createContext<
  PanelPropsContextType | undefined
>(undefined);

export const PanelPropsProvider: React.FC<ChildProviderProps> = ({
  children,
}) => {
  const [panelProps, setPanelProps] = useState<PanelProps>(null);

  return (
    <PanelPropsContext.Provider value={{ panelProps, setPanelProps }}>
      {children}
    </PanelPropsContext.Provider>
  );
};

export const usePanelProps = (): PanelPropsContextType => {
  const context = useContext(PanelPropsContext);
  if (!context) {
    throw new Error(
      "usePanelProps must be used within a usePanelPropsProvider"
    );
  }
  return context;
};
